import React from "react";
import {
  getPoweredByLogoForWhiteLabeling,
  getPoweredByUrlForWhiteLabeling,
} from "../../services/white_label";

function Footer() {
  const handleRedirect = () => {
    window.location.href = getPoweredByUrlForWhiteLabeling();
  };
  console.log(
    "getPoweredByLogoForWhiteLabeling",
    getPoweredByLogoForWhiteLabeling()
  );
  console.log(
    "getPoweredByUrlForWhiteLabeling",
    getPoweredByUrlForWhiteLabeling()
  );

  return (
    <div className=" p-6 absolute bottom-0 md:relative md:flex md:items-end w-full justify-center pb-2">
      <div className="">
        <div className="flex flex-col items-center justify-center filter p-4 ">
          <p className="text-xs mb-2 text-gray-500">Powered by</p>
          <img
            src={getPoweredByLogoForWhiteLabeling()}
            className="object-cover h-7 w-35 flex  justify-center cursor-pointer"
            alt="logo"
            onClick={handleRedirect}
          />
        </div>
        <div className="flex  justify-center space-x-2 opacity-70 text-xs">
          <a
            className="hover:text-primary text-gray-500 underline"
            href="https://app.reaidy.io/TermsOfUse"
            // target="_blank"
            rel="noopener noreferrer"
          >
            Terms of use
          </a>
          <span>|</span>{" "}
          <a
            className="hover:text-primary text-gray-500 underline"
            href="https://app.reaidy.io/PrivacyPolicy"
            // target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </a>
        </div>
      </div>
      {/* <HelpCenter position="/" /> */}
    </div>
  );
}
export default Footer;
